import React, { useState } from 'react';
import axios from 'axios';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // Import Quill styles
import ComanServices from '../../../services/ComanServices';

function AddBlog() {
  const [formData, setFormData] = useState({
    title: '',
    author: '',
    startDate: '',
    endDate: '',
    description: '', // Will now handle HTML content
    file: null,
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    setFormData({ ...formData, file: e.target.files[0] });
  };

  // Handle change for the rich text editor (description field)
  const handleDescriptionChange = (value) => {
    setFormData({ ...formData, description: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Form data for file upload
    const data = new FormData();
    data.append('title', formData.title);
    data.append('author', formData.author);
    data.append('startDate', formData.startDate);
    data.append('endDate', formData.endDate);
    data.append('description', formData.description); // HTML content
    data.append('image', formData.file);

    try {
      const response = await ComanServices.addBlog(data);
      console.log('Blog added successfully', response.data);
      alert('Blog added successfully!');
    } catch (error) {
      console.error('There was an error adding the blog!', error);
      alert('Failed to add blog. Please try again.');
    }
  };

  return (
    <div className="right_col" role="main">
      <div className="title-box">
        <h2>Blog Add</h2>
        <div className="container-box-top-header-right">
          <a className="list-banner-btn" href="/admin/blog-list">
            Blogs List
          </a>
        </div>
      </div>
      <div className="container-box px-5">
        <div className="container-box-inner">
          <div className="page-details">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-6">
                  <div className="input-field">
                    <label>Title</label>
                    <input
                      type="text"
                      name="title"
                      value={formData.title}
                      onChange={handleInputChange}
                      className="form-control"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="input-field">
                    <label>Author</label>
                    <input
                      type="text"
                      name="author"
                      value={formData.author}
                      onChange={handleInputChange}
                      className="form-control"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-3 col-sm-6">
                  <div className="input-field">
                    <label>Start Date</label>
                    <input
                      type="date"
                      name="startDate"
                      value={formData.startDate}
                      onChange={handleInputChange}
                      className="form-control"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-3 col-sm-6">
                  <div className="input-field">
                    <label>End Date</label>
                    <input
                      type="date"
                      name="endDate"
                      value={formData.endDate}
                      onChange={handleInputChange}
                      className="form-control"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="input-field">
                    <label>
                      Upload<span className="red">*</span>
                    </label>
                    <input
                      type="file"
                      name="file"
                      onChange={handleFileChange}
                      className="form-control"
                      required
                    />
                    <p>
                      <span>
                        Drop an image or Paste URL (upto resolution 1,500 x 1,500 px),
                      </span>{' '}
                      Supported formats: png, jpeg, jpg, webp
                    </p>
                    <div className="file-preview text-center">
                      <img
                        id="uploadFile"
                        src={formData.file ? URL.createObjectURL(formData.file) : 'img/placeholder-img.png'}
                        alt="your image"
                        style={{ maxWidth: '150px', maxHeight: '150px' }}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="input-field">
                    <label>Description</label>
                    <ReactQuill
                      value={formData.description}
                      onChange={handleDescriptionChange}
                      theme="snow"
                      className="form-control"
                      required
                    />
                  </div>
                </div>
              </div>
              <button type="submit" className="submit-green-btn">
                SUBMIT
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddBlog;
